<template>
  <div>
    <el-table
      ref="table"
      :data="tableData"
      style="width: 100%"
      :header-cell-style="{
        background: 'rgba(193,193,193,0.4)',
        color: '#000000',
      }"
      :cell-style="this.cellStyle"
      v-bind="$attrs"
      v-on="$listeners"
      @row-click="rowClick"
      @cell-click="cellClick"
    >
      <!--编号-->
      <el-table-column :width="80" label="No." align="center"  v-if="isIndex===true">
        <template slot-scope="scope">
          <span style="color: #3447ff">{{ scope.$index + 1 }}</span>
        </template>
      </el-table-column>

      <!--默认内容部分-->
      <template v-for="(item, index) in column">
        <el-table-column
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          :align="item.align ? item.align : 'center'"
          :sort-method="
            (a, b) => {
              return a[item.prop] - b[item.prop];
            }
          "
          :sortable="sortable"
        >
          <template slot-scope="scope">
            <template v-if="item.prop === 'catName'">
              <span style="color: #97270f">{{ scope.row[item.prop] }}</span>
            </template>
            <template v-else-if="item.prop === 'plcName'">
              <span style="color: #3884db;text-decoration:underline;cursor: pointer;">{{ scope.row[item.prop] }}</span>
            </template>
            <template v-else-if="item.prop === 'published'">
              <span style="color: #0e6914">
               [{{ published(scope.row[item.prop]) }}]
              </span>
            </template>
            <template v-else>{{ scope.row[item.prop] }}</template>
          </template>
        </el-table-column>
      </template>
    </el-table>
    <div style="position: relative; height: 50px" v-if="pageable">
      <div style="position: absolute; right: 0; top: 10px">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageConfig.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageConfig.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="pageConfig.total"
        >
        </el-pagination>
      </div>
    </div>

    <el-dialog
      title="Notes"
      :center="true"
      :visible.sync="dialogVisible"
      width="1194px"
    >
      <div class="box">
        <div style="font-size:14px;">Published:{{ InfoList.time }}</div>
        <div v-html="InfoList.content"></div>
      </div>
      <div slot="title" class="dialog-title">
        <h2 style="font-size:23px;color:#000;font-weight:500;" v-html="InfoList.title"></h2>
      </div>
    </el-dialog>

    <el-dialog
      title="Notes"
      :center="true"
      :visible.sync="dialogVisible1"
      width="1194px"
      :before-close="handleClose"
    >
      <div class="box" style="overflow: auto; height: 600px">
        <div class="box-add-Source"><span>Date: {{ time }} </span> <span>{{source}}</span></div>
        <div>
          <div v-html="contentText"></div>
          <div
            style="text-decoration: underline; color: blue; cursor: pointer"
            v-for="(item, index) in fileList"
            :key="index"
            @click="downLoadUrl(item)"
          >
            {{ item.fileName }}
          </div>
        </div>

      </div>
      <div slot="title" class="dialog-title">
        <h2
          v-html="title"
          style="
            font-size: 23px;
            line-height: 23px;
            color: #000000;
            letter-spacing: -0.46px;
            text-align: center;
            margin: 0;
            font-weight:500;
          "
        ></h2>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pako from 'pako'
import moment from 'moment'
import request from '../../../ftaUtils/http'
import baseUrl from '../../../ftaUtils/baseUrl'

export default {
  props: {
    sortable: {
      type: Boolean,
      default: false,
    },
    tableData: {
      type: Array /* 数据 */
    },
    isIndex: {
      type: Boolean,
      default: true
    },
    column: {
      type: Array /* 列表头 */
    },
    pageConfig: {
      type: Object /* 分页配置 */,
      default () {
        return {
          total: 0,
          page: 1,
          pageSize: 10
        }
      }
    },
    pageable: {
      type: Boolean,
      default: false
    },
    scrollStar: {
      type: Boolean,
      default: false
    },
    diaLogShow: {
      type: Boolean,
      default: false
    },
    cellStyle: {
      type: Object,
      default () {
        return {
          background: '#fff'
        }
      }
    },
    path: {
      type: String,
      default: '/'
    },
    parameter: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      journalismInfo:{"state":true,"data":{"id":320891,"title":"SW. China's Chongqing to deepen economic and trade cooperation with ASEAN","editor":"Hu Pingchao","has_thumb":1,"published":"2021-04-13 17:24:26","appid":1,"is_pay":0,"price":0,"category_name":"News for Outlets","description":"Southwest China's Chongqing Municipality has recently unveiled an action plan for deepening economic and trade cooperation with the ASEAN countries from 2021 to 2025, according to the Chongqing Municipal Commission of Commerce on Tuesday.","thumb":"https:\/\/img.imsilkroad.com\/a\/icmp\/2021\/04\/13\/2021041352840432\/73a76f4ab67c4899966b285740adf196.png","content":"<p style=\"text-align: center;\"><img imagerela=\"2804951\" src=\"https:\/\/img.imsilkroad.com\/a\/icmp\/2021\/04\/13\/2021041352840432\/abf885be08924b6a8707f6fd43dfa72b.png\" title=\"Chongqing.png\" alt=\"Chongqing.png\"><\/p>\n<p>Photo taken on April 26, 2019 shows the first \"new international land-sea trade corridor\" rail-ocean intermodal train bound for Indonesia in southwest China's Chongqing. (Xinhua\/Liu Chan)<\/p>\n<p>BEIJING, April 13 (Xinhua) -- Southwest China's Chongqing Municipality has recently unveiled an action plan for deepening economic and trade cooperation with the ASEAN countries from 2021 to 2025, according to the Chongqing Municipal Commission of Commerce on Tuesday.&nbsp;<\/p>\n<p>According to the action plan, Chongqing targets more than 20 billion U.S. dollars worth of trade volume of goods with ASEAN and over 15 billion U.S. dollars of investment from the ASEAN countries in actual use, by 2025.&nbsp;<\/p>\n<p>Meanwhile, Chongqing aims to bring its implementation of service outsourcing from ASEAN countries to more than 500 million U.S. dollars, and the number of Chongqing-funded enterprises in the ASEAN countries to more than 150 by 2025, said the plan.&nbsp;<\/p>\n<p>An official of the Chongqing Municipal Commission of Commerce said that in 2019 and 2020, ASEAN had been Chongqing's largest trading partner for two consecutive years. In 2020, the import and export volume with ASEAN countries was 112.17 billion yuan, accounting for 18.1 percent of the city's total import and export volume. As of the end of 2020, the amount of the foreign capital from ASEAN countries in actual use had been 12.51 billion U.S. dollars for Chongqing.&nbsp;<\/p>\n<p>In fact, many enterprises in Chongqing have taken root in the ASEAN countries. In 2014, the Chongqing-based Sokon Group selected Indonesia as its first choice for overseas investment. Since the completion of its plant in Indonesia in 2018, the company has formed a \"3+1\" product system in Indonesia with three SUV models and one \"super cab\" model.&nbsp;<\/p>\n<p>The introduction of the action plan will help Chongqing seize the major opportunities brought by the Regional Comprehensive Economic Partnership (RCEP) to accelerate opening-up of the inland areas, according to Fang Chaojun, Associate Professor of Chongqing Finance and Economics College. (Edited by Hu Pingchao with Xinhua Silk Road, hupingchao@xinhua.org)<\/p>","keyword":["Chongqing","ASEAN","RCEP"],"author":["Hu Pingchao"],"source":"Xinhua Silk Road","isCollect":0,"isDigg":0,"attachment":[],"space":null}},
      timer: null,
      dialogVisible: false,
      dialogVisible1: false,
      InfoList: {
        title: '',
        time: '',
        content: ''
      },
      contentText: '',
      title: '',
      plcName: '',
      time: '',
      fileList: [],
      source:''
    }
  },
  computed: {
    published () {
      return function (data) {
        const datas = data.toString().length == 10 ?  data * 1000 : data;
        //  console.log(datas,888888)
        // return `[${moment(data).format('YYYY-MM-DD HH:mm:ss')}]`
        return `${moment(datas).format('YYYY-MM-DD')}`
      }
    }
  },
  methods: {
    handleSizeChange (val) {
      this.pageConfig.page = val
      const data = {
        ...this.pageConfig,
        pageSize: val
      }
      this.$emit('pageConfigs', data)
      // this.$emit("getDate", data);
    },
    handleCurrentChange (val) {
      const data = {
        ...this.pageConfig,
        page: val
      }
      this.$emit('pageConfigs', data)
      // this.$emit("getDate", data);
    },
    // 弹窗事件
    rowClick (row) {
      if (this.parameter) {

      } else {
        if (this.diaLogShow) {
          this.dialogVisible = true
          // 请求数据
          const id = row.id

          //  没有cookie 的假数据
          // this.InfoList.title = this.journalismInfo.data.title
          // this.InfoList.time = this.journalismInfo.data.published
          // const content = '<div style="padding:12px 20px;font-size: 14px;color: ' +
          //         '#4f5362;background: #E8EAEF;margin-bottom: 30px;width: 98%"><div>' + this.journalismInfo.data.description + '</div></div>' + '<div>' + this.journalismInfo.data.content + '</div>' +
          //         '<div style="margin-top: 20px;font-size: 12px;color: #80828d">' + 'Editor：' + this.journalismInfo.data.editor + '</div>'
          // const text = content.replace('<img','<img style="display:block;width:70%;margin:0 auto"')
          // this.InfoList.content = text
          
          
          // this.$http
          //   .post(`${baseUrl.base_3}/api/pc/getarticledetail`, {
          //     id: id
          //   })
          request('post',`${baseUrl.base_3}/api/pc/getarticledetail`,{id:id})
            .then((res) => {
            this.InfoList.title = res.data.data.title
            this.InfoList.time = res.data.data.published
            const content = '<div style="padding:12px 20px;font-size: 14px;color: ' +
            '#4f5362;background: #E8EAEF;margin-bottom: 30px;width: 98%"><div>' + res.data.data.description + '</div></div>' + '<div>' + res.data.data.content + '</div>' +
            '<div style="margin-top: 20px;font-size: 12px;color: #80828d">' + 'Editor：' + res.data.data.editor + '</div>'
            const text = content.replace('<img','<img style="display:block;width:70%;margin:0 auto"')
            
            this.InfoList.content = text
            })
        }
      }
    },
    cellClick (row, column, cell, event) {

      if (this.parameter) {
        if (column.property === this.parameter) {
          if (this.diaLogShow) {
            this.title = row[this.parameter]
            this.plcName = row[this.parameter]
            this.time = row.releaseDate
            this.source = row.engSrc
            request('get', `${baseUrl.base_1}${this.path}${encodeURIComponent(encodeURIComponent(this.plcName))}`)
              .then((res) => {
                if (res.data) {
                  this.dialogVisible1 = true
                  this.contentText = res.data
                }
              })
              .then((res) => (this.fileList = row.fileList))
          }
        }
      }
    },
    handleClose () {
      this.dialogVisible1 = false
      this.contentText = ''
      this.fileList = []
    },
    downLoadUrl (obj) {
      request('post', `${baseUrl.base_1}/policy/downloadFile`, {
        fileName: obj.fileName,
        plcName: obj.plcName
      }).then((res) => {
        let blob = new Blob([res.data], { type: 'application/octet-stream' })
        let url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = obj.fileName // 重命名文件
        link.click()
        window.URL.revokeObjectURL(url) // 释放内存
      })
    }
    // pako_ungzip(str) {
    //   try {
    //     var restored = pako.ungzip(str, { to: "string" });
    //   } catch (err) {
    //     console.log("异常:" + err);
    //   }
    //   return restored;
    // },
  },
  mounted () {},
  watch: {
    // scrollStar: {
    //   handler: function (val) {
    //     this.$nextTick(() => {
    //       if (val) {
    //         clearInterval(this.timer)
    //         const table = this.$refs.table
    //         const divData = table.bodyWrapper
    //         this.timer = setInterval(() => {
    //           divData.scrollTop += 1
    //           if (
    //             divData.clientHeight + divData.scrollTop ==
    //             divData.scrollHeight
    //           ) {
    //             divData.scrollTop = 0
    //           }
    //         }, 100)
    //       } else {
    //         clearInterval(this.timer)
    //       }
    //     })
    //   },
    //   immediate: true
    // }
  },
  destroyed () {
    clearInterval(this.timer)
  }
}
</script>

<style scoped>
/*::v-deep .el-dialog__header {*/
/*  height: 90px;*/
/*  padding: 0;*/
/*  padding-top: 34px;*/
/*  box-sizing: border-box;*/
/*}*/

/*::v-deep .el-dialog__header .dialog-title h2 {*/
/*  font-family: SourceHanSansCN-Medium;*/
/*  font-size: 23px;*/
/*  line-height: 23px;*/
/*  color: #000000;*/
/*  letter-spacing: -0.46px;*/
/*  text-align: center;*/
/*  margin: 0;*/
/*}*/

/*::v-deep .el-dialog__body {*/
/*  padding: 0px 27px 12px 31px;*/
/*}*/

.box > div:nth-of-type(1) {
  border-top: 1px solid #e6e6e6;
  padding-top: 9px;
  font-size: 14px;
  color: #000000;
  letter-spacing: -0.28px;
  height: 42px;
}

.box > div:nth-of-type(2) {
  height: 453px;
  overflow: auto;
  font-size: 19px;
  color: #000000;
  letter-spacing: -0.38px;
  line-height: 30px;
  text-indent: 2rem;
}

 .el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: rgba(52, 71, 255, 0.2) !important;
}

 .el-table__header-wrapper {
  height: 34px;
  background: #eef1f6;
  /*border: 1px solid rgba(151, 151, 151, 0.3);*/
  /*border-radius: 5px;*/
}

 .el-table th {
  padding: 0;
  text-align: center;
  font-size: 14px;
  color: red;
  letter-spacing: -0.28px;
  background: rgb(230, 229, 229);
  border-left: 1px solid #bebebe;
}

 .el-table td {
  padding: 5px 0;
  font-size: 14px;
}

 .el-table th:first-child {
  border-left: 0;
}

 .el-table th:nth-last-child(1) {
  border-left: 0;
}

.el-table th .cell {
  line-height: 32px;
}
.box-add-Source{
  display: flex;
  justify-content: space-between;
}
</style>
